import { Outlet } from 'react-router-dom';
import AdminHeader from '../Headers/AdminHeader';

import Sidebar from '../SideBar/Sidebar';
import { useState } from 'react';
import useAutoAlerteSonore from '../../Services/Alert';

const AdminLayout = () => {
   const[iscollapsed,setIsCollapsed]=useState<boolean>(false);
   useAutoAlerteSonore();
  return (
    <>
      <AdminHeader />
      <div className="admin-layout" >
        <Sidebar iscollapsed={iscollapsed} setIsCollapsed={setIsCollapsed}/>
        <main className={`admin-main ${iscollapsed ? 'collapsed' : ''}`}>
          <Outlet /> 
        </main>
      </div>
    </>
  );
};

export default AdminLayout;
